import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { filterNotFound } from 'src/app/modules/search/services/search-query.service'

@Component({
  selector: 'app-item-group-not-found',
  imports: [CommonModule],
  templateUrl: './item-group-not-found.component.html',
  styleUrls: ['./item-group-not-found.component.scss'],
})
export class ItemGroupNotFoundComponent implements OnInit {
  @Input()
  selected!: boolean

  @Input()
  group!: filterNotFound

  constructor() {}

  ngOnInit() {}
}
